// Max pointer travel (screen px) between down and up for a gesture to count as a
// tap. Larger movements are camera drags and must not trigger click actions.
export const TAP_SLOP_PX = 20;
// Distinguishes taps from drags. Wire the returned handlers to the target's
// pointerdown / pointerup / pointercancel events (works for both actors and
// isometric tiles, whose event emitters have incompatible static types).
export function createTapHandler(onTap) {
    let startPos = null;
    return {
        down(evt) {
            startPos = evt.screenPos.clone();
        },
        up(evt) {
            if (startPos && evt.screenPos.distance(startPos) < TAP_SLOP_PX)
                onTap(evt);
            startPos = null;
        },
        cancel() {
            startPos = null;
        },
    };
}
